import axios from 'axios';

const instance =  axios.create(
    {baseURL: 'https://markers-fromzeroton-default-rtdb.firebaseio.com/'}
);

export default instance;